module.exports = __webpack_public_path__ + "static/media/qr_code_slider_phone1.5c6fe873.png";